import React from "react";
import "./Notificcation.css";
import {data} from '../../../DummyData'
import styled from "styled-components";

export const NotificationWrapper = styled.div`
    display: ${(props) => props.display};
    background-color: #262626;
    max-width: 485px;
    padding: 10px 20px 20px 20px;
    border-radius: 20px;
    color: #ffffff;
    box-sizing: border-box;
    font-family: "Poppins";
    position: absolute;
    top: 130px;
    right: 97px;
    z-index: 1;
    flex-direction:column;

`

export const UnreadNotfications = ({ message, sentDate, footerlink,  time, status }) => {
  
  return (
    <div className="notification__bar">
      <div className="notification__status">
        <div
          className={`notifications__status_icon notifications__status_on`}
        ></div>
      </div>
      <h4>{message}</h4>
      <div className="notification__footer">
        <h5>Sent {sentDate}</h5>
        <h5 className="footer__link"><a>{footerlink}</a></h5>
      </div>
    </div>
  );
};


export const ReadNotificactions = ({ message , footerlink ,sentDate, time, status}) => {
  return(
    <div className="notification__bar">
    <h4>{message}</h4>
    <div className="notification__footer">
        <h5>Sent {sentDate}</h5>
        <h5 className="footer__link"><a>{footerlink}</a></h5>
    </div>
  </div>
);
}


const Notifications = ({display}) => {
  return (
    <NotificationWrapper display={display} className="notifications__wrapper">
      <h3>Notifications</h3>
      <div className="notifications__wrapper_inner">

        {
          data.map(function(info){
            if(info.status == 'on'){
              return(
                <UnreadNotfications 
                message ={info.message}
                sentDate={info.sentDate}
                footerlink={info.footerLink}
                />
              )
            }else{
              return(
                <ReadNotificactions 
                message ={info.message}
                sentDate={info.sentDate}
                footerlink={info.footerLink}
                />
              )
            }
          })
        }

      </div>
    </NotificationWrapper>
  );
};
export default Notifications;
